import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'StockStatus/All', method: 'GET', body: null, token: token })
}
